export default {
  app: {
    golf: {
      title: 'Informácie o ihrisku',
      hasEVChargingPoint: 'Nabíjací bod pre elektromobily',
      hasCaddieService: 'Služba nosiča',
      hasTrolley: 'Vozík',
      hasBuggy: 'Bugina',
      hasClubRental: 'Požičanie palíc',
      hasAcademy: 'Akadémia',
      hasMarshal: 'Maršal',
      hasPGACertification: 'PGA certifikácia',
      hasTrainingArea: 'Tréningová zóna',
      hasRestaurant: 'Reštaurácia',
      hasHotel: 'Hotel',
      hasDogsOnCourse: 'Psy na ihrisku',
      numberOfHoles: 'Počet jamiek',
    },
  },
};
